<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Miss Nation Competition</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="text-justify">
           <p>Grace, grit, and glamour lit up the stage at GHRCACS, Nagpur during the Miss Nation Competition.</p>
        </div>
        <div class="row mb-20 mt-5">
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-2.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-2.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-7.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-7.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-3.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-3.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-5.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-5.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-6.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-6.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            
        </div>
    </div>
</section>